import {Utils} from "../common/utils";
import useSWR from "swr";
import {StandardResponse} from "../types/swr";
import {DatasourceTemplate} from "Stores/superStore/schools";

const clientConfigs = Utils.getEAIClientConfigs();


export function useDataSourceTemplates() {
    const {data, error, mutate} = useSWR<StandardResponse<DatasourceTemplate[]>, Error>(`${clientConfigs.baseUrl}/datasources/templates`);

    return {
        data: data?.data,
        error,
        mutate
    };
}
